import React from 'react'

import { SvgWrapper } from './SvgWrapper/SvgWrapper'

export const DefaultAlcoholSvg = ({ size = 24 }) => (
  <SvgWrapper size={size}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.39123 2C0.0755898 2 -0.441116 3.70628 0.653492 4.43617L11.957 11.9734L23.265 4.43631C24.3598 3.70655 23.8432 2 22.5275 2H1.39123Z"
      fill="#D7E0EE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.9913 7.32863L11.9571 11.9734L18.8883 7.35353"
      fill="#D7E0EE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.21327 21.9871C6.71473 22.2006 6.86726 22.9441 7.4096 22.9441H16.5134C17.0556 22.9441 17.2083 22.2009 16.7099 21.9872L11.9645 19.9521L7.21327 21.9871Z"
      fill="#D7E0EE"
    />
    <path d="M11.9601 10.9761V20.5899" stroke="#D7E0EE" strokeWidth="1.49601" />
  </SvgWrapper>
)
